import { Color, Object3D } from 'three';
import { Catenary3D } from '../../catenary-answer';
import { Global } from '../../global.model';
import { Simulation } from '../../simulation.model';
import { GlobalBuilder } from '../object-builders/global-builder.model';
import GraphicProperties from './graphic-properties.model';

export class GlobalGraphicProperties extends GraphicProperties {
  color: Color;

  updateColor(color: Color): void {}

  async build(riser: Catenary3D, simulation: Simulation, global: Global): Promise<Object3D> {
    this.object = await this.getBuilder().build(riser, simulation, global);
    return this.object;
  }

  getBuilder(): GlobalBuilder {
    return new GlobalBuilder();
  }
}
